import WallPrintCanvas from "./walls/WallPrintCanvas";
import YurtPrintCanvas from "./walls/yurt/YurtPrintCanvas";
import { pixels } from "../build/projects/CreateNewProject";

const AllDrawings = ({ walls, yurtTrait }) => {
  return (
    <div>
      <YurtPrintCanvas
        yurtTrait={yurtTrait}
        wallTrait={walls}
        pixels={pixels}
      />
      {walls.map(function (wall, i) {
        return <WallPrintCanvas trait={wall} yurtTrait={yurtTrait} />;
      })}
    </div>
  );
};

export default AllDrawings;